import React from 'react';
import Flatpickr from "react-flatpickr";
import moment from 'moment';

import "flatpickr/dist/themes/dark.css";


export const DateSelector = (props) => {
  
  let onCloseCalendar = (selectedDates, dateStr, instance) => {
    if (props.onSet) { 
        props.onSet(moment(selectedDates[0]).format("YYYY-MM-DD")) 
      }
  }


    let errorClass
    let dD = props.defDate || moment().format('YYYY-MM-DD')
    
    dD = moment(dD).format("DD.MM.YYYY")

    
    if (props.isError) {
       errorClass = "is-danger"
    }

    return( <div>
        
        <div class="control has-text-grey">
          <Flatpickr defaultValue={dD} className={"input has-text-grey c-date-picker " + errorClass } 
              options={{ dateFormat: "d.m.Y", minDate: props.minDate }} onClose={onCloseCalendar}/>
        </div>
        { (props.isError) && <Error>{props.errorMessage}</Error>}    

     </div>
    );

}



export const TimeSelector = (props) => {
  
  let onCloseCalendar = (selectedDates, dateStr, instance) => {
    if (props.onSet) { props.onSet(moment(selectedDates[0]).format("HH:mm")) }
  }


    let errorClass
    let dT = props.defTime || "00:00"

    if (props.isError) {
       errorClass = "is-danger"
    }


    return( <div>
        
    <div class="control has-text-grey">
      <Flatpickr step="60" defaultValue={dT} className={"input has-text-grey c-date-picker " + errorClass } options={{ 
        enableTime: true,
        noCalendar: true,
        minDate: props.minDate,
        dateFormat: "H:i",
        time_24hr: true,
        onClose: onCloseCalendar }} />
   </div>
      { (props.isError) && <Error>{props.errorMessage}</Error>}    


     </div>
    );

}




const Error = (props) => {

   return ( 
       
          <div class="help"><div class="notification is-danger is-size-6-desktop">
            <span class="icon is-normal is-left" style={{marginRight:"0.5rem"}}><i class="fas fa-exclamation-triangle"></i></span>
            <span>{props.children}</span></div>
          </div>

    )
}

